export const getFilenameWithExtensionFromUrl = url => {
  if (!url) {
    return ''
  }
  const [file] = url
    .split('/')
    .pop()
    .match(/[\w,\s-]+\.[A-Za-z]{3}/)

  return file || ''
}

export const imageExtension = /(\.jpg|\.jpeg|\.png|\.gif)$/i



// WEBPACK FOOTER //
// ./src/Utils/Regexp/index.js